import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.js';



// WEBPACK FOOTER //
// ./js/common/fancybox.js